<ng-container *ngIf="showBreakdown">
  <ng-container *ngIf="variant === 'compact'; else detailedTpl">
    <div class="gw-flex gw-flex-col gw-gap-2x-small">
      <ng-container *ngIf="hasFee; else compactNoFee">
        <div class="gw-flex gw-items-baseline gw-justify-between gw-gap-small">
          <span class="gw-text-text-secondary gw-text-sm gw-font-normal">
            {{
              'common.paymentReceipt.amountBreakdown.recipientReceives'
                | translate
            }}
          </span>
          <span
            class="gw-text-text-primary gw-text-lg gw-font-extrabold gw-tabular-nums"
          >
            {{ compactHeroAmount | currency : 'BRL' }}
          </span>
        </div>
        <div
          *ngIf="!isAddFeesMode"
          class="gw-flex gw-items-baseline gw-justify-between gw-gap-small gw-text-sm"
        >
          <span class="gw-text-text-secondary">
            {{
              'common.paymentReceipt.amountBreakdown.requestedAmount'
                | translate
            }}
          </span>
          <span class="gw-text-text-secondary gw-tabular-nums">
            {{ enteredAmount | currency : 'BRL' }}
          </span>
        </div>
        <div
          class="gw-flex gw-items-baseline gw-justify-between gw-gap-small gw-text-sm"
        >
          <span class="gw-text-text-secondary">
            {{ 'common.paymentReceipt.amountBreakdown.fee' | translate }}
          </span>
          <span class="gw-text-text-secondary gw-tabular-nums">
            {{ feePrefix }} {{ calculatedFee | currency : 'BRL' }}
          </span>
        </div>
        <div
          *ngIf="isAddFeesMode"
          class="gw-flex gw-items-baseline gw-justify-between gw-gap-small gw-text-sm"
        >
          <span class="gw-text-text-secondary">
            {{
              'common.paymentReceipt.amountBreakdown.walletDebit' | translate
            }}
          </span>
          <span class="gw-text-text-secondary gw-tabular-nums">
            {{ amount | currency : 'BRL' }}
          </span>
        </div>
      </ng-container>
      <ng-template #compactNoFee>
        <div class="gw-flex gw-flex-col">
          <span
            class="gw-text-text-primary gw-text-lg gw-font-extrabold gw-tabular-nums"
          >
            {{ resolvedFinalAmount | currency : 'BRL' }}
          </span>
          <span class="gw-text-text-secondary gw-font-normal gw-text-sm">
            {{
              'common.paymentReceipt.amountBreakdown.recipientReceives'
                | translate
            }}
          </span>
        </div>
      </ng-template>
    </div>
  </ng-container>

  <ng-template #detailedTpl>
    <div
      class="gw-rounded-lg gw-border-base-neutral gw-bg-background-elevation-1 gw-p-medium gw-mb-medium"
    >
      <ng-container *ngIf="hasFee; else detailedNoFee">
        <div
          class="gw-flex gw-items-center gw-justify-between gw-gap-small gw-mb-small"
        >
          <span class="gw-text-sm gw-font-medium gw-text-text-secondary">
            {{
              'common.paymentReceipt.amountBreakdown.requestedAmount'
                | translate
            }}
          </span>
          <span class="gw-text-base gw-text-text-primary gw-tabular-nums">
            {{ enteredAmount | currency : 'BRL' }}
          </span>
        </div>
        <div
          class="gw-flex gw-items-center gw-justify-between gw-gap-small gw-mb-small"
        >
          <span class="gw-text-sm gw-font-medium gw-text-text-secondary">
            {{ 'common.paymentReceipt.amountBreakdown.fee' | translate }}
          </span>
          <span class="gw-text-base gw-text-text-secondary gw-tabular-nums">
            {{ feePrefix }} {{ calculatedFee | currency : 'BRL' }}
          </span>
        </div>
        <div
          class="gw-h-px gw-w-full gw-bg-border-normal gw-my-small"
          aria-hidden="true"
        ></div>
        <div class="gw-flex gw-items-center gw-justify-between gw-gap-small">
          <span class="gw-text-sm gw-font-semibold gw-text-text-primary">
            {{ detailedEmphasisLabelKey | translate }}
          </span>
          <span
            class="gw-text-xl gw-font-extrabold gw-text-text-primary gw-tabular-nums"
          >
            {{ detailedEmphasisAmount | currency : 'BRL' }}
          </span>
        </div>
      </ng-container>
      <ng-template #detailedNoFee>
        <div class="gw-flex gw-items-center gw-justify-between gw-gap-small">
          <span class="gw-text-sm gw-font-medium gw-text-text-secondary">
            {{
              'common.paymentReceipt.amountBreakdown.recipientReceives'
                | translate
            }}
          </span>
          <span
            class="gw-text-xl gw-font-extrabold gw-text-text-primary gw-tabular-nums"
          >
            {{ resolvedFinalAmount | currency : 'BRL' }}
          </span>
        </div>
      </ng-template>
    </div>
  </ng-template>
</ng-container>
